<div class="flex flex-wrap -mx-2 overflow-auto flex-1 pb-6">
  <div *ngFor="let month of skeletonMonths" class="w-full xl:w-1/2 sm:w-full px-2 mb-4">
    <div
      class="bg-white rounded-lg border shadow overflow-hidden min-h-[325px] dark:border-none dark:bg-dark-panel dark:shadow-none">

      <div class="text-xl font-semibold text-center p-4 border-b dark:text-white dark:border-dark-background-alt">
        <div class="animate-pulse bg-gray-300 dark:bg-gray-600 h-6 w-32 mx-auto rounded"></div>
      </div>


      <div class="grid grid-cols-7">

        <div *ngFor="let dayName of weekDays; let i0 = index"
          class="text-center font-bold py-2 dark:border-dark-background-alt dark:text-white"
          [ngClass]="{'border-r': i0 <= 5}">
          <div class="animate-pulse bg-gray-300 dark:bg-gray-600 h-4 w-8 mx-auto rounded"></div>
        </div>

        <div *ngFor="let day of month.days; let i = index" class="py-1 text-center relative" [ngClass]="{
            'border-r': !(i % 7 === 6),
            'dark:border-dark-background-alt': !(i % 7 === 6)
          }">

          <div *ngIf="!day.isEmpty" class="relative">

            <div class="animate-pulse bg-gray-300 dark:bg-gray-600 h-4 w-6 mx-auto rounded mb-1"></div>


            <div *ngIf="day.hasEvents" class="flex justify-center mt-1">
              <div class="animate-pulse bg-gray-400 dark:bg-gray-500 w-2 h-2 rounded-full mx-0.5"></div>
              <div class="animate-pulse bg-gray-400 dark:bg-gray-500 w-2 h-2 rounded-full mx-0.5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
